<template>
  <app-layout title="Create Branch">
    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 mt-2">
      <div class="w-full">
        <div class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4">
          <DxPopup
            v-model:visible="createPopupVisible"
            :show-close-button="false"
            :close-on-outside-click="false"
            :show-title="true"
            :resizeEnabled="true"
            :title="creatTitle"
          >
            <!-- <DxTabs
              :data-source="tabs"
              v-model:selected-index="selectedIndex"
            /> -->

            <!-- <DxToolbarItem
              widget="dxButton"
              toolbar="bottom"
              location="before"
              :options="closeButtonOptions"
            /> -->

            <DxToolbarItem
              widget="dxButton"
              toolbar="bottom"
              location="after"
              :visible="isNextVisible"
              :options="nextButtonOptions"
            />

            <DxToolbarItem
              widget="dxButton"
              toolbar="bottom"
              location="after"
              :visible="isSaveVisible"
              :options="saveButtonOptions"
            />

            <DxTabPanel
              class="px-2"
              :loop="true"
              :animation-enabled="true"
              :swipe-enabled="true"
              v-model:selected-index="selectedIndex"
            >
              >
              <DxItem :title="'Organisation'">
                <div class="mt-2 mb-2 px-3">
                  <BsOnBoardForm
                    :createDef="this.organisationDef"
                    @is_gst="handleGstChange"
                    @is_multi="handleCustomChange"
                    ref="organisationRef"
                  />
                </div>
              </DxItem>

              <DxItem :visible="isTaxVisible" :title="'Tax Unit'">
                <div class="mt-2 mb-2 px-3">
                  <BsOnBoardForm :createDef="this.taxDef" ref="taxRef" />
                </div>
              </DxItem>

              <DxItem :visible="isAddressVisible" :title="'Address'">
                <div class="mt-2 mb-2 px-3">
                  <BsOnBoardForm :createDef="this.addDef" ref="addressRef" />
                </div>
              </DxItem>
            </DxTabPanel>
          </DxPopup>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import Welcome from "@/Jetstream/Welcome.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";
import DxRadioGroup from "devextreme-vue/radio-group";
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxLabel,
} from "devextreme-vue/form";
import { DxScrollView } from "devextreme-vue/scroll-view";
import DxTabs from "devextreme-vue/tabs";
import DxTabPanel, { DxItem } from "devextreme-vue/tab-panel";

import {
  DxColumn,
  DxFormItem,
  DxEditing,
  DxLookup,
  DxGrouping,
  DxColumnChooser,
  DxLoadPanel,
  DxToolbar,
  DxDataGrid,
  DxSelection,
  DxFilterRow,
  DxScrolling,
  DxPager,
  DxPaging,
} from "devextreme-vue/data-grid";

import { DxTextArea } from "devextreme-vue/text-area";
import BsOnBoardForm from "@include/forms/BsOnBoardForm";
import { DxPopup, DxPosition, DxToolbarItem } from "devextreme-vue/popup";

import { mergeProps } from "vue";
export default {
  props: {
    taxDef: {
      type: Array,
      default: [],
    },
    organisationDef: {
      type: Array,
      default: [],
    },
    addDef: {
      type: Array,
      default: [],
    },
  },
  components: {
    AppLayout,
    Welcome,
    PageTitle,
    JetNavLink,
    DxForm,
    DxTextArea,
    DxGroupItem,
    DxSimpleItem,
    DxLabel,
    BsOnBoardForm,

    DxScrollView,
    DxColumn,
    DxFormItem,
    DxEditing,
    DxLookup,
    DxGrouping,
    DxColumnChooser,
    DxLoadPanel,
    DxToolbar,
    DxDataGrid,
    DxSelection,
    DxFilterRow,
    DxScrolling,
    DxPager,
    DxPaging,
    DxPopup,
    DxPosition,
    DxToolbarItem,
    DxTabs,
    DxTabPanel,
    DxItem,
    DxRadioGroup,
  },
  data() {
    return {
      title: "Create Branch",
      labelLocation: "top",
      createPopupVisible: true,
      isTaxVisible: false,
      isAddressVisible: false,
      isNextVisible: true,
      isSaveVisible: false,
      isGst: "no",
      isMultiBranch: "no",
      finalData: { org: {}, add: {}, tax: {} },
      saveButtonOptions: {
        icon: "save",
        text: "Save",
        onClick: this.saveRecord,
      },

      closeButtonOptions: {
        text: "Close",
        onClick: () => {
          this.createPopupVisible = false;
        },
      },

      nextButtonOptions: {
        text: "Next",
        onClick: this.moveNext,
      },
      selectedIndex: 0,
      tabs: ["Organisation", "Address", "GST Info"],
    };
  },
  methods: {
    moveNext(e) {
      if (this.selectedIndex == 0) {
        console.log("Selected INDEX " + this.selectedIndex);
        this.isGst = this.$refs.organisationRef.formData.is_gst;
        this.isMultiBranch =
          this.$refs.organisationRef.formData.is_multi_branch;
        this.finalData.org = this.$refs.organisationRef.formData;
        //this.finalData.add = this.$refs.organisationRef.formData;

        console.log("ORG FINAL", this.finalData.org);

        this.conFirst();
      } else if (this.selectedIndex == 1) {
        console.log("Selected INDEX yha pr hai");

        this.finalData.tax = this.$refs.taxRef.formData;

        this.conSecond();
      } else {
      }
    },

    saveRecord() {
      // console.log(this.$refs.organisationRef.formData);
      if (this.isMultiBranch == "yes") {
        this.finalData.add = this.$refs.addressRef.formData;
      }
      if (this.isGst == "no" && this.isMultiBranch == "no") {
        this.finalData.org = this.$refs.organisationRef.formData;
      }

      if (this.isGst == "yes" && this.isMultiBranch == "no") {
        this.finalData.tax = this.$refs.taxRef.formData;
      }

      if (this.isGst == "no" && this.isMultiBranch == "yes") {
        this.finalData.add = this.$refs.addressRef.formData;
      }

      this.$inertia.post(route("save.branch", this.finalData));
      //console.log("final data",this.finalData);
    },
    conFirst() {
      if (this.isGst == "yes" && this.isMultiBranch == "yes") {
        this.isTaxVisible = true;
        this.isAddressVisible = true;
        this.isNextVisible = true;
        this.isSaveVisible = false;
        this.selectedIndex = 1;
      }
      if (this.isGst == "yes" && this.isMultiBranch == "no") {
        this.isTaxVisible = true;
        this.isAddressVisible = false;
        this.isNextVisible = false;
        this.isSaveVisible = true;
        this.selectedIndex = 1;
      }
      if (this.isGst == "no" && this.isMultiBranch == "yes") {
        this.selectedIndex = 2;
        this.isAddressVisible = true;
        //console.log("Address DEF"+this.addDef)
        this.isTaxVisible = false;
        this.isNextVisible = false;
        this.isSaveVisible = true;
      }
    },

    conSecond() {
      //ye hai mtlb next me jyega toh address hai
      //save button dikhega
      //next button hide hoga
      this.isAddressVisible = true;
      this.isNextVisible = false;
      this.isSaveVisible = true;
      this.selectedIndex = 2;
    },

    handleCustomChange(s) {
      this.isMultiBranch = s;
      console.log(
        "CUSTOM GST" + this.isGst + " CUSTOM MULTI" + this.isMultiBranch
      );

      if (this.isGst == "yes" && this.isMultiBranch == "yes") {
        (this.isNextVisible = true), (this.isSaveVisible = false);
      } else if (this.isGst == "no" && this.isMultiBranch == "no") {
        (this.isNextVisible = false), (this.isSaveVisible = true);
      } else if (this.isGst == "no" && this.isMultiBranch == "yes") {
        (this.isNextVisible = true), (this.isSaveVisible = false);
      } else if (this.isGst == "yes" && this.isMultiBranch == "no") {
        (this.isNextVisible = true), (this.isSaveVisible = false);
      }

      //alert(s);
    },
    handleGstChange(s) {
      this.isGst = s;
      console.log("GST" + this.isGst + "MULTI" + this.isMultiBranch);

      if (this.isGst == "yes" && this.isMultiBranch == "yes") {
        (this.isNextVisible = true), (this.isSaveVisible = false);
      } else if (this.isGst == "no" && this.isMultiBranch == "no") {
        (this.isNextVisible = false), (this.isSaveVisible = true);
      } else if (this.isGst == "no" && this.isMultiBranch == "yes") {
        (this.isNextVisible = true), (this.isSaveVisible = false);
      } else if (this.isGst == "yes" && this.isMultiBranch == "no") {
        (this.isNextVisible = true), (this.isSaveVisible = false);
      }

      //alert(s);
    },
  },
  mounted() {
    formDef: [];
  },
};
</script>


<style>
#elip {
  overflow: hidden;
  width: 260px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently supported by Chrome and Opera */
}
/* .img-company {
  width: 50px;
  height: 50px;
} */
.no-decoration {
  text-decoration: none;
}
.no-decoration:hover {
  text-decoration: none;
}

/* after steps */
.card {
  background-color: #fff;
  border-radius: var(--card-radius);
  position: relative;
}
.card:hover {
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.15);
}
.radio {
  font-size: inherit;
  margin: 0;
  position: absolute;
  right: calc(var(--card-padding) + var(--radio-border-width));
  top: calc(var(--card-padding) + var(--radio-border-width));
}
@supports (-webkit-appearance: none) or (-moz-appearance: none) {
  .radio {
    -webkit-appearance: none;
    -moz-appearance: none;
    background: #fff;
    border: var(--radio-border-width) solid var(--color-gray);
    border-radius: 50%;
    cursor: pointer;
    height: var(--radio-size);
    outline: none;
    transition: background 0.2s ease-out, border-color 0.2s ease-out;
    width: var(--radio-size);
  }
  .radio::after {
    border: var(--radio-border-width) solid #fff;
    border-top: 0;
    border-left: 0;
    content: "";
    display: block;
    height: 0.75rem;
    left: 25%;
    position: absolute;
    top: 50%;
    transform: rotate(45deg) translate(-50%, -50%);
    width: 0.375rem;
  }
  .radio:checked {
    background: var(--color-green);
    border-color: var(--color-green);
  }
  .card:hover .radio {
    border-color: var(--color-dark-gray);
  }
  .card:hover .radio:checked {
    border-color: var(--color-green);
    --tw-ring-color: rgba(27, 243, 167, 0.886);
    background: var(--color-green);
  }
}
[type="radio"] {
  color: var(--color-green);
}
input[type="radio"] {
  --tw-ring-color: rgba(27, 243, 167, 0.886) !important;
}

.plan-details {
  border: var(--radio-border-width) solid var(--color-gray);
  border-radius: var(--card-radius);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  padding: var(--card-padding);
  transition: border-color 0.2s ease-out;
}
.card:hover .plan-details {
  border-color: var(--color-dark-gray);
}
.radio:checked ~ .plan-details {
  border-color: var(--color-green);
}
.radio:focus ~ .plan-details {
  box-shadow: 0 0 0 2px var(--color-dark-gray);
}
.radio:disabled ~ .plan-details {
  color: var(--color-dark-gray);
  cursor: default;
}

.card:hover .radio:disabled ~ .plan-details {
  border-color: var(--color-gray);
  box-shadow: none;
}
.card:hover .radio:disabled {
  border-color: var(--color-gray);
}
.hidden-visually {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
:root {
  --card-line-height: 1.2em;
  --card-padding: 1em;
  --card-radius: 0.5em;
  --color-green: #0ecb8f;
  --color-gray: #e2ebf6;
  --color-dark-gray: #c4d1e1;
  --radio-border-width: 2px;
  --radio-size: 1.5em;
}
.bigitem {
  /* This will be twice as big as the small item. */
  -webkit-flex: 2 0 0;
  flex: 2 0 0;
  height: 15%;
  min-height: 200px;
}

.smallitem {
  -webkit-flex: 1 0 0;
  flex: 1 0 0;
  height: 20%;
  min-height: 200px;
}
</style>
